<template>
  <v-app-bar
    app
    flat
    dark
    height="2.75rem"
    class="navbar-compacto"
  >

    <!-- ========================= -->
    <!-- LOGO -->
    <!-- ========================= -->

    <router-link
      to="/"
      class="logo-link"
    >
      <v-img
        src="@/assets/images/logoPequenio.png"
        max-height="40"
        max-width="40"
        contain
        class="mr-3"
      />
    </router-link>

    <v-spacer />


    <!-- ========================= -->
    <!-- DESKTOP -->
    <!-- ========================= -->

    <div class="nav-links hidden-sm-and-down">

      <v-btn
        class="nav-btn"
        text
        @click="goToHeroSection"
      >
        Inicio
      </v-btn>

      <v-btn
        class="nav-btn"
        text
        @click="goToLevelSection"
      >
        Level
      </v-btn>

      <v-btn
        class="nav-btn"
        text
        @click="goToCategorySection"
      >
        Category
      </v-btn>

      <v-btn
        class="nav-btn"
        text
        to="/contacto"
      >
        Contact
      </v-btn>


      <!-- ========================= -->
      <!-- SIGN IN / MYPOLE DESKTOP -->
      <!-- ========================= -->

      <v-btn
        class="sign-in-btn"
        text
        @click="goToUserArea"
      >
        <v-icon
          left
          small
        >
          mdi-account-circle-outline
        </v-icon>

        {{ isLoggedIn ? "MyPole" : "Sign in" }}
      </v-btn>

    </div>


    <!-- ========================= -->
    <!-- MOBILE -->
    <!-- ========================= -->

    <div class="hidden-md-and-up mobile-actions">

      <!-- ========================= -->
      <!-- SIGN IN / MYPOLE MOBILE -->
      <!-- ========================= -->

      <v-btn
        text
        small
        class="mobile-sign-in"
        @click="goToUserArea"
      >
        <v-icon
          left
          small
        >
          mdi-account-circle-outline
        </v-icon>

        {{ isLoggedIn ? "MyPole" : "Sign in" }}
      </v-btn>


      <!-- ========================= -->
      <!-- HAMBURGER MENU -->
      <!-- ========================= -->

      <v-menu
        offset-y
        left
      >

        <template v-slot:activator="{ on, attrs }">

          <v-btn
            icon
            dark
            class="menu-btn"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>
              mdi-menu
            </v-icon>
          </v-btn>

        </template>

        <v-list>

          <v-list-item
            @click="goToHeroSection"
            link
          >
            <v-list-item-title>
              Home
            </v-list-item-title>
          </v-list-item>

          <v-list-item
            @click="goToLevelSection"
            link
          >
            <v-list-item-title>
              Level
            </v-list-item-title>
          </v-list-item>

          <v-list-item
            @click="goToCategorySection"
            link
          >
            <v-list-item-title>
              Category
            </v-list-item-title>
          </v-list-item>

          <v-list-item
            to="/contacto"
            link
          >
            <v-list-item-title>
              Contact
            </v-list-item-title>
          </v-list-item>

          <v-list-item
            @click="goToUserArea"
            link
          >
            <v-list-item-title>
              {{ isLoggedIn ? "MyPole" : "Sign in" }}
            </v-list-item-title>
          </v-list-item>

        </v-list>

      </v-menu>

    </div>

  </v-app-bar>
</template>


<script>

export default {

  name: "NavBar",

  data() {

    return {

      isLoggedIn: false

    };

  },


  mounted() {

    this.checkLogin();

  },


  watch: {

    $route() {

      this.checkLogin();

    }

  },


  methods: {

    /* ========================= */
    /* LOGIN STATUS */
    /* ========================= */

    checkLogin() {

      /*
       * Usamos los nombres de token que puede
       * estar utilizando actualmente tu login.
       *
       * Si existe cualquiera, consideramos
       * al cliente autenticado.
       */

      const token =
        localStorage.getItem("cliente_token") ||
        localStorage.getItem("token") ||
        localStorage.getItem("auth_token");

      this.isLoggedIn = !!token;

    },


    /* ========================= */
    /* SIGN IN / MYPOLE */
    /* ========================= */

    goToUserArea() {

      this.checkLogin();

      /*
       * CLIENTE LOGUEADO
       *
       * Nunca lo mandamos nuevamente al login.
       */

      if (this.isLoggedIn) {

        if (this.$route.name === "mypole") {
          return;
        }

        this.$router.push({
          name: "mypole"
        });

        return;

      }


      /*
       * CLIENTE NO LOGUEADO
       */

      if (this.$route.name === "cliente-login") {
        return;
      }

      this.$router.push({
        name: "cliente-login"
      });

    },


    /* ========================= */
    /* LEVEL */
    /* ========================= */

    goToLevelSection() {

      if (this.$route.path === "/") {

        const section =
          document.getElementById(
            "levelSection"
          );

        if (section) {

          section.scrollIntoView({
            behavior: "smooth"
          });

        }

        return;

      }


      this.$router.push("/");

      this.$nextTick(() => {

        setTimeout(() => {

          const section =
            document.getElementById(
              "levelSection"
            );

          if (section) {

            section.scrollIntoView({
              behavior: "smooth"
            });

          }

        }, 300);

      });

    },


    /* ========================= */
    /* CATEGORY */
    /* ========================= */

    goToCategorySection() {

      const goToCategory = () => {

        const category =
          document.getElementById(
            "categorySection"
          );

        if (!category) {

          console.error(
            "NO EXISTE #categorySection"
          );

          return;

        }

        category.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest"
        });

      };


      if (this.$route.path === "/") {

        goToCategory();

        return;

      }


      this.$router.push("/");

      setTimeout(() => {

        goToCategory();

      }, 300);

    },


    /* ========================= */
    /* HOME */
    /* ========================= */

    goToHeroSection() {

      if (this.$route.path === "/") {

        const section =
          document.getElementById(
            "heroSection"
          );

        if (section) {

          section.scrollIntoView({
            behavior: "smooth"
          });

        }

        return;

      }


      this.$router.push("/");

      this.$nextTick(() => {

        setTimeout(() => {

          const section =
            document.getElementById(
              "heroSection"
            );

          if (section) {

            section.scrollIntoView({
              behavior: "smooth"
            });

          }

        }, 300);

      });

    }

  }

};

</script>


<style scoped>

/* ========================= */
/* NAVBAR */
/* ========================= */

.navbar-compacto {
  padding: 0 !important;
  height: 2rem !important;
}

.navbar-compacto::v-deep .v-toolbar__content {
  height: 2rem !important;
  min-height: 2rem !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  align-items: center !important;
}


/* ========================= */
/* LOGO */
/* ========================= */

.logo-link {
  display: flex;
  align-items: center;
  text-decoration: none;
}

.logo-link .v-image {
  flex-shrink: 0;
}


/* ========================= */
/* DESKTOP */
/* ========================= */

.nav-links {
  height: 100%;
  display: flex;
  align-items: center;
}

.nav-btn {
  height: 100% !important;
  min-height: 100% !important;
  min-width: auto !important;
  margin: 0 !important;
  padding-inline: 0.8rem !important;

  display: flex !important;
  align-items: center !important;
  justify-content: center !important;

  font-size: 0.86rem;
  line-height: 1;
  text-transform: none;
  white-space: nowrap;
}


/* ========================= */
/* SIGN IN / MYPOLE DESKTOP */
/* ========================= */

.sign-in-btn {
  height: 1.75rem !important;
  min-height: 1.75rem !important;
  min-width: auto !important;

  margin-left: 0.65rem !important;

  padding: 0 0.85rem !important;

  border: 1px solid rgba(255,255,255,.22);

  border-radius: 999px;

  color: white !important;

  font-size: 0.78rem;

  font-weight: 600;

  text-transform: none;

  transition: 0.2s;
}

.sign-in-btn:hover {
  background: rgba(255,255,255,.10);

  border-color: rgba(255,255,255,.45);
}


/* ========================= */
/* MOBILE */
/* ========================= */

.mobile-actions {
  height: 100%;

  display: flex;

  align-items: center;

  gap: 0.15rem;
}


/* ========================= */
/* SIGN IN / MYPOLE MOBILE */
/* ========================= */

.mobile-sign-in {
  height: 1.75rem !important;

  min-width: auto !important;

  padding: 0 0.45rem !important;

  color: white !important;

  font-size: 0.72rem;

  font-weight: 600;

  text-transform: none;

  letter-spacing: 0.01em;
}


/* ========================= */
/* HAMBURGER */
/* ========================= */

.menu-btn {
  width: 2rem !important;

  height: 2rem !important;

  min-width: 2rem !important;

  align-self: center;
}

.menu-btn::v-deep .v-btn__content {
  display: flex;

  align-items: center;

  justify-content: center;
}


/* ========================= */
/* MOBILE CHICO */
/* ========================= */

@media (max-width: 600px) {

  .logo-link .v-image {
    max-width: 38px !important;
    max-height: 38px !important;
  }

  .mobile-sign-in {
    height: 1.65rem !important;

    padding: 0 0.3rem !important;

    font-size: 0.68rem;
  }

  .mobile-sign-in::v-deep .v-icon {
    font-size: 17px !important;

    margin-right: 4px !important;
  }

  .menu-btn {
    width: 2rem !important;

    height: 2rem !important;

    min-width: 2rem !important;
  }

}

</style>